
// import React, { useState, useEffect } from 'react';

// const Product = () => {
//   const words = ["PRODUCTS", "SOLUTIONS", "INNOVATIONS"];
//   const [index, setIndex] = useState(0);

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setIndex((prev) => (prev + 1) % words.length);
//     }, 3000);
//     return () => clearInterval(timer);
//   }, []);

//   const data = [
//     { id: "01", title: "Web Applications", desc: "Unlock flexibility with our ERP software's intuitive web applications, granting seamless data access and management from any device, anywhere, anytime. Experience enhanced collaboration and productivity as your team stays connected on the go.", gradient: "linear-gradient(135deg, #00f2fe 0%, #4facfe 100%)" },
//     { id: "02", title: "Mobile Applications", desc: "Experience the freedom of managing your business data anytime, anywhere with our ERP software's mobile applications. Designed for seamless integration into your workflow.", gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" },
//     { id: "03", title: "Sales And Procurements", desc: "Revolutionize your supply chain operations with our advanced ERP software, designed to elevate sales and procurement management. Seamlessly integrate processes.", gradient: "linear-gradient(135deg, #2af598 0%, #009efd 100%)" },
//     { id: "04", title: "Finance And HR", desc: "Empower your business with our integrated ERP software, delivering robust solutions for finance and HR management. Drive efficiency and compliance with our tailored tools.", gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" }
//   ];

//   return (
//     <div style={styles.section} className="product-section">
//       <div style={styles.headerArea} className="product-header">
//         <h2 style={styles.heading} className="product-heading">
//           What We Do Provide <br />

//           <div className="wave-text-container">
//             <div className="wave-text">
//               {words.map((word, wIdx) => (
//                 <div
//                   key={wIdx}
//                   className={`specific-word ${wIdx === index ? 'active' : 'before-active'}`}
//                 >
//                   {word.split("").map((letter, lIdx) => (
//                     <span
//                       key={lIdx}
//                       className="letter"
//                       style={{
//                         animationDelay: `${lIdx * 60}ms`
//                       }}
//                     >
//                       {letter === " " ? "\u00A0" : letter}
//                     </span>
//                   ))}
//                 </div>
//               ))}
//             </div>
//           </div>
//         </h2>
//       </div>

//       <div style={styles.customGrid} className="product-grid">
//         {data.map((item, idx) => (
//           <div key={idx} style={styles.glassCard} className="hover-card product-card">
//             <div style={styles.topRow}>
//               <span style={{ ...styles.number, color: item.gradient.split(' ')[4] }} className="product-card-number">{item.id}</span>
//             </div>
//             <h3 style={styles.cardTitle} className="product-card-title">{item.title}</h3>
//             <p style={styles.cardText} className="product-card-text">{item.desc}</p>
//             <div style={{ ...styles.bottomLine, background: item.gradient }}></div>
//           </div>
//         ))}
//       </div>

//       <style>
//         {`
//           .wave-text-container {
//             height: 60px;
//             overflow: hidden;
//             position: relative;
//             display: inline-block;
//             width: 100%;
//           }

//           .wave-text {
//             display: flex;
//             position: relative;
//             height: 100%;
//           }

//           .specific-word {
//             position: absolute;
//             left: 0;
//             top: 0;
//             display: flex;
//             opacity: 0;
//             visibility: hidden;
//           }

//           .specific-word.active, .specific-word.before-active {
//             opacity: 1;
//             visibility: visible;
//           }

//           .letter {
//             display: inline-block;
//             font-size: 40px;
//             font-weight: 800;
//             color: #4facfe;
//             letter-spacing: -0.5px;
//             transform: translateY(110%);
//             animation-duration: 1800ms;
//             animation-fill-mode: forwards;
//           }

//           .active .letter {
//             animation-name: centricSlowIn;
//             animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
//           }

//           .before-active .letter {
//             animation-name: centricSlowOut;
//             animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
//           }

//           @keyframes centricSlowIn {
//             0% { transform: translateY(110%); opacity: 0; }
//             100% { transform: translateY(0); opacity: 1; }
//           }

//           @keyframes centricSlowOut {
//             0% { transform: translateY(0); opacity: 1; }
//             100% { transform: translateY(-110%); opacity: 0; }
//           }

//           .hover-card {
//             transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//             position: relative;
//           }
//           .hover-card:hover {
//             transform: scale(1.02);
//             background: rgba(255, 255, 255, 0.08) !important;
//             box-shadow: 0 20px 50px rgba(0,0,0,0.5);
//           }
//           .hover-card:hover div:last-child {
//             width: 100% !important;
//           }

//           /* ── RESPONSIVE ── */

//           /* Tablet: 768px */
//           @media (max-width: 768px) {
//             .product-section {
//               padding: 70px 6% !important;
//             }
//             .product-grid {
//               grid-template-columns: 1fr !important;
//               gap: 28px !important;
//             }
//             .product-heading {
//               font-size: 30px !important;
//             }
//             .letter {
//               font-size: 30px !important;
//             }
//             .wave-text-container {
//               height: 46px !important;
//             }
//           }

//           /* Mobile: 480px */
//           @media (max-width: 480px) {
//             .product-section {
//               padding: 50px 5% !important;
//             }
//             .product-heading {
//               font-size: 24px !important;
//             }
//             .letter {
//               font-size: 24px !important;
//             }
//             .wave-text-container {
//               height: 38px !important;
//             }
//             .product-card {
//               padding: 28px 22px !important;
//               border-radius: 20px 4px 20px 4px !important;
//             }
//             .product-card-title {
//               font-size: 20px !important;
//             }
//             .product-card-number {
//               font-size: 26px !important;
//             }
//           }

//           /* Small Mobile: 360px */
//           @media (max-width: 390px) {
//             .product-section {
//               padding: 40px 4% !important;
//             }
//             .product-heading {
//               font-size: 20px !important;
//             }
//             .letter {
//               font-size: 20px !important;
//               letter-spacing: -1px !important;
//             }
//             .wave-text-container {
//               height: 32px !important;
//             }
//             .product-card {
//               padding: 22px 16px !important;
//             }
//             .product-card-title {
//               font-size: 17px !important;
//               margin-bottom: 12px !important;
//             }
//             .product-card-text {
//               font-size: 13px !important;
//             }
//             .product-card-number {
//               font-size: 22px !important;
//             }
//             .product-grid {
//               gap: 20px !important;
//             }
//             .product-header {
//               margin-bottom: 50px !important;
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// const styles = {
//   section: {
//     backgroundColor: '#050505', padding: '100px 8%',
//     fontFamily: "'Inter', sans-serif", color: '#fff', minHeight: '100vh'
//   },
//   headerArea: { textAlign: 'left', marginBottom: '80px', borderLeft: '4px solid #4facfe', paddingLeft: '25px' },
//   heading: { fontSize: '40px', fontWeight: '800', margin: '10px 0', lineHeight: '1.2', letterSpacing: '0.5px' },
//   customGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px' },
//   glassCard: { background: 'rgba(255, 255, 255, 0.03)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: '30px 5px 30px 5px', padding: '40px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' },
//   topRow: { display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '20px' },
//   number: { fontSize: '32px', fontWeight: 'bold', opacity: 0.6 },
//   cardTitle: { fontSize: '24px', fontWeight: '700', marginBottom: '20px' },
//   cardText: {
//     color: '#aaa',
//     lineHeight: '1.7', fontSize: '15px', fontFamily: "'Open Sans',sans-serif",
//   },
//   bottomLine: { height: '4px', width: '40px', marginTop: '30px', borderRadius: '2px', transition: '0.4s ease' }
// };

// export default Product;

import React, { useState, useEffect } from 'react';

const Product = () => {
  const words = ["PRODUCTS", "SOLUTIONS", "INNOVATIONS"];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const data = [
    { id: "01", title: "Web Applications", desc: "Unlock flexibility with our ERP software's intuitive web applications, granting seamless data access and management from any device, anywhere, anytime. Experience enhanced collaboration and productivity as your team stays connected on the go.", gradient: "linear-gradient(135deg, #00f2fe 0%, #4facfe 100%)" },
    { id: "02", title: "Mobile Applications", desc: "Experience the freedom of managing your business data anytime, anywhere with our ERP software's mobile applications. Designed for seamless integration into your workflow.", gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" },
    { id: "03", title: "Sales And Procurements", desc: "Revolutionize your supply chain operations with our advanced ERP software, designed to elevate sales and procurement management. Seamlessly integrate processes.", gradient: "linear-gradient(135deg, #2af598 0%, #009efd 100%)" },
    { id: "04", title: "Finance And HR", desc: "Empower your business with our integrated ERP software, delivering robust solutions for finance and HR management. Drive efficiency and compliance with our tailored tools.", gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" }
  ];

  return (
    <div style={styles.section} className="product-section">

      {/* Header */}
      <div
        style={styles.headerArea}
        className="product-header"
        data-aos="fade-right"
        data-aos-duration="1000"
      >
        <h2 style={styles.heading} className="product-heading">
          What We Do Provide <br />
          <div className="wave-text-container">
            <div className="wave-text">
              {words.map((word, wIdx) => (
                <div key={wIdx} className={`specific-word ${wIdx === index ? 'active' : 'before-active'}`}>
                  {word.split("").map((letter, lIdx) => (
                    <span key={lIdx} className="letter" style={{ animationDelay: `${lIdx * 60}ms` }}>
                      {letter === " " ? "\u00A0" : letter}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </h2>
      </div>

      {/* Cards */}
      <div style={styles.customGrid} className="product-grid">
        {data.map((item, idx) => (
          <div
            key={idx}
            style={styles.glassCard}
            className="hover-card product-card"
            data-aos="fade-up"
            data-aos-duration="900"
            data-aos-delay={`${idx * 100}`}
          >
            <div style={styles.topRow}>
              <span style={{ ...styles.number, color: item.gradient.split(' ')[4] }} className="product-card-number">
                {item.id}
              </span>
            </div>
            <h3 style={styles.cardTitle} className="product-card-title">{item.title}</h3>
            <p style={styles.cardText} className="product-card-text">{item.desc}</p>
            <div style={{ ...styles.bottomLine, background: item.gradient }}></div>
          </div>
        ))}
      </div>

      <style>{`
        .wave-text-container {
          height: 60px; overflow: hidden;
          position: relative; display: inline-block; width: 100%;
        }
        .wave-text { display: flex; position: relative; height: 100%; }
        .specific-word {
          position: absolute; left: 0; top: 0;
          display: flex; opacity: 0; visibility: hidden;
        }
        .specific-word.active, .specific-word.before-active {
          opacity: 1; visibility: visible;
        }
        .letter {
          display: inline-block; font-size: 40px; font-weight: 800;
          color: #4facfe; letter-spacing: -0.5px;
          transform: translateY(110%);
          animation-duration: 1800ms; animation-fill-mode: forwards;
        }
        .active .letter {
          animation-name: centricSlowIn;
          animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
        }
        .before-active .letter {
          animation-name: centricSlowOut;
          animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
        }
        @keyframes centricSlowIn {
          0% { transform: translateY(110%); opacity: 0; }
          100% { transform: translateY(0); opacity: 1; }
        }
        @keyframes centricSlowOut {
          0% { transform: translateY(0); opacity: 1; }
          100% { transform: translateY(-110%); opacity: 0; }
        }
        .hover-card {
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          position: relative;
        }
        .hover-card:hover {
          transform: scale(1.02) translateY(-4px);
          background: rgba(255, 255, 255, 0.08) !important;
          box-shadow: 0 20px 50px rgba(0,0,0,0.5);
        }
        .hover-card:hover div:last-child { width: 100% !important; }

        @media (max-width: 768px) {
          .product-section { padding: 70px 6% !important; }
          .product-grid { grid-template-columns: 1fr !important; gap: 28px !important; }
          .product-heading { font-size: 30px !important; }
          .letter { font-size: 30px !important; }
          .wave-text-container { height: 46px !important; }
        }
        @media (max-width: 480px) {
          .product-section { padding: 50px 5% !important; }
          .product-heading { font-size: 24px !important; }
          .letter { font-size: 24px !important; }
          .wave-text-container { height: 38px !important; }
          .product-card { padding: 28px 22px !important; border-radius: 20px 4px 20px 4px !important; }
          .product-card-title { font-size: 20px !important; }
          .product-card-number { font-size: 26px !important; }
        }
        @media (max-width: 390px) {
          .product-section { padding: 40px 4% !important; }
          .product-heading { font-size: 20px !important; }
          .letter { font-size: 20px !important; letter-spacing: -1px !important; }
          .wave-text-container { height: 32px !important; }
          .product-card { padding: 22px 16px !important; }
          .product-card-title { font-size: 17px !important; margin-bottom: 12px !important; }
          .product-card-text { font-size: 13px !important; }
          .product-card-number { font-size: 22px !important; }
          .product-grid { gap: 20px !important; }
          .product-header { margin-bottom: 50px !important; }
        }
      `}</style>
    </div>
  );
};

const styles = {
  section: { backgroundColor: '#050505', padding: '100px 8%', fontFamily: "'Inter', sans-serif", color: '#fff', minHeight: '100vh' },
  headerArea: { textAlign: 'left', marginBottom: '80px', borderLeft: '4px solid #4facfe', paddingLeft: '25px' },
  heading: { fontSize: '40px', fontWeight: '800', margin: '10px 0', lineHeight: '1.2', letterSpacing: '0.5px' },
  customGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px' },
  glassCard: { background: 'rgba(255,255,255,0.03)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '30px 5px 30px 5px', padding: '40px', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' },
  topRow: { display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginBottom: '20px' },
  number: { fontSize: '32px', fontWeight: 'bold', opacity: 0.6 },
  cardTitle: { fontSize: '24px', fontWeight: '700', marginBottom: '20px' },
  cardText: { color: '#aaa', lineHeight: '1.7', fontSize: '15px', fontFamily: "'Open Sans',sans-serif" },
  bottomLine: { height: '4px', width: '40px', marginTop: '30px', borderRadius: '2px', transition: '0.4s ease' }
};

export default Product;